<div class="flex flex-col gap-4">

    <p-card header="Renewal Report">

        <app-saved-search [formGroup]="searchForm" searchType="renewalReport" (searchClick)="search()"
            [loading]="loading()">
            <div>
                <label>Original Trip Location</label>
                <app-location-multi-dropdown formControlName="originalLocation" [options]="locations()"></app-location-multi-dropdown>
            </div>
            <div>
                <label>Renewal Location</label>
                <app-location-multi-dropdown formControlName="renewalLocation" [options]="locations()"></app-location-multi-dropdown>
            </div>
            <div>
                <label>Trip Leaders</label>
                <app-staff-dropdown-multi formControlName="tripLeaders" [options]="staffService2.activeTripLeaders()"></app-staff-dropdown-multi>
            </div>
            <div>
                <label>Consultants</label>
                <app-staff-dropdown-multi formControlName="consultants" [options]="staffService2.activeConsultants()"></app-staff-dropdown-multi>
            </div>
            <div>
                <label>Original Trip Date Window</label>
                <app-date-range-picker formControlName="tripDateRange" [presets]="tripDatePresets"></app-date-range-picker>
            </div>
            <div>
                <label>Renewal Date Window</label>
                <app-date-range-picker formControlName="renewalDateRange" [presets]="renewalPresets"></app-date-range-picker>
            </div>
            <div>
                <label>Min Attendees</label>
                <p-inputNumber formControlName="minAttendees" [min]="0"></p-inputNumber>
            </div>
            <div>
                <label>Max Attendees</label>
                <p-inputNumber formControlName="maxAttendees" [min]="0"></p-inputNumber>
            </div>
        </app-saved-search>

    </p-card>


    @if(loading()) {
    <app-table-skeleton [columnCount]="10" [rowCount]="10"></app-table-skeleton>
    }
    @else {
    @if(!initialSearchComplete()) {
    <div class="text-center text-2xl">Click search to begin</div>
    }
    @else {

    <div class="grid grid-cols-2 gap-4">
        <p-card header="Overall Summary" class="col-span-2 md:col-span-1">
            <p-table #summaryTable [value]="overallSummaryData()" [columns]="summaryColumns()" [paginator]="true"
                [rows]="10" [rowsPerPageOptions]="[10, 25, 50, 100]" sortMode="multiple"
                [multiSortMeta]="defaultSummaryTableSort()">
                <ng-template pTemplate="caption">
                    <app-table-caption [table]="summaryTable"></app-table-caption>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <app-table-headers [columns]="summaryColumns()"></app-table-headers>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-row>
                    <tr>
                        <app-table-columns [data]="row" [filterTable]="tripTable" (cellClick)="filterTeamByTeamTable($event)" [columns]="summaryColumns()"></app-table-columns>
                    </tr>
                </ng-template>
            </p-table>
        </p-card>

        <p-card header="Location Summary" class="col-span-2 md:col-span-1">
            <p-table #locationSummaryTable [value]="locationSummaryData()" [columns]="locationSummaryColumns()"
                [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10, 25, 50, 100]" sortMode="multiple"
                [multiSortMeta]="defaultLocationSummaryTableSort()">

                <ng-template pTemplate="caption">
                    <app-table-caption [table]="locationSummaryTable"></app-table-caption>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <app-table-headers [columns]="locationSummaryColumns()"></app-table-headers>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-row>
                    <tr>
                        <app-table-columns [data]="row" [filterTable]="tripTable" (cellClick)="filterTeamByTeamTable($event)" [columns]="locationSummaryColumns()"></app-table-columns>
                    </tr>
                </ng-template>
            </p-table>
        </p-card>

        <p-card header="TL Summary" class="col-span-2 md:col-span-1">
            <p-table #tlSummaryTable [value]="tlSummaryData()" [columns]="tlSummaryColumns()" [paginator]="true"
                [rows]="10" [rowsPerPageOptions]="[10, 25, 50, 100]" sortMode="multiple"
                [multiSortMeta]="defaultTLSummaryTableSort()">

                <ng-template pTemplate="caption">
                    <app-table-caption [table]="tlSummaryTable"></app-table-caption>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <app-table-headers [columns]="tlSummaryColumns()"></app-table-headers>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-row>
                    <tr>
                        <app-table-columns [data]="row" [filterTable]="tripTable" (cellClick)="filterTeamByTeamTable($event)" [columns]="tlSummaryColumns()"></app-table-columns>
                    </tr>
                </ng-template>
            </p-table>
        </p-card>

        <p-card header="Consultant Summary" class="col-span-2 md:col-span-1">
            <p-table #consultantSummaryTable [value]="consultantSummaryData()" [columns]="consultantSummaryColumns()"
                [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10, 25, 50, 100]" sortMode="multiple"
                [multiSortMeta]="defaultConsultantSummaryTableSort()">

                <ng-template pTemplate="caption">
                    <app-table-caption [table]="consultantSummaryTable"></app-table-caption>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <app-table-headers [columns]="consultantSummaryColumns()"></app-table-headers>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-row>
                    <tr>
                        <app-table-columns [data]="row" [filterTable]="tripTable" (cellClick)="filterTeamByTeamTable($event)" [columns]="consultantSummaryColumns()"></app-table-columns>
                    </tr>
                </ng-template>
            </p-table>
        </p-card>
    </div>

    <p-card header="Team by Team">
        <p-table #tripTable [value]="tripTableData()" [columns]="tripTableColumns()" [paginator]="true" [rows]="10"
            [rowsPerPageOptions]="[10, 25, 50, 100]" sortMode="multiple" [multiSortMeta]="defaultTripTableSort()">
            <ng-template pTemplate="caption">
                <app-table-caption [table]="tripTable"></app-table-caption>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <app-table-headers [columns]="tripTableColumns()"></app-table-headers>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
                <tr>
                    <app-table-columns [data]="row" [columns]="tripTableColumns()"></app-table-columns>
                </tr>
            </ng-template>
        </p-table>
    </p-card>

    <p-card header="Trip Follow Up (Consulting Follow Up call at 80% or more)">
        <p-table #followUpReportTable [value]="followUpReportData()" [columns]="followUpReportColumns()"
            [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10, 25, 50, 100]" sortMode="multiple"
            [multiSortMeta]="defaultFollowUpReportTableSort()">
            <ng-template pTemplate="caption">
                <app-table-caption [table]="followUpReportTable"></app-table-caption>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <app-table-headers [columns]="followUpReportColumns()"></app-table-headers>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
                <tr>
                    <app-table-columns [data]="row" [columns]="followUpReportColumns()"></app-table-columns>
                </tr>
            </ng-template>
            <ng-template pTemplate="summary">
               
                        <div class="italic">This report is not affected by the renewal window or location</div>
               
            </ng-template>
        </p-table>
    </p-card>

    <p-card header="Renewal Rate %">
        <app-renewal-pace-graph [reportYear]="paceReportYear()" [minAttendees]="paceReportMinAttendees()"
            [maxAttendees]="paceReportMaxAttendees()" [originalLocationIds]="paceReportOriginalLocationIds()"
            [tripLeaders]="paceReportTripLeaders()" [consultants]="paceReportConsultants()"></app-renewal-pace-graph>
        
            <div class="italic mt-2">This report is not affected by the renewal window or location</div>
    </p-card>

    }
    }

</div>